import mapLanguageOptions from "./mapLanguageOptions";

function doctorChatLanguages(abiLanguagesFromBackend) {
  return mapLanguageOptions(abiLanguagesFromBackend);
}

export default doctorChatLanguages;
